<template>
  <v-app>
    <Navigation></Navigation>
    <v-content>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-footer color="grey darken-3" dark app>
      <v-layout align-center justify-center>
         <strong>DIF Oaxaca </strong>&nbsp; &copy; Copyright {{ new Date().getFullYear() }}.
      </v-layout>
    </v-footer>
  </v-app>
</template>

<style>
.btn-text-left .v-btn__content{
  justify-content: left
}

.title-table {
  font-family: TodaySHOP !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  font-size: 24px !important;
  color: #98579B !important;
}
</style>


<script>
import Navigation from './components/Navigation.vue'

export default {
  components: {
    Navigation
  },
  data: () => ({
    usuario:{
      nombre:"Nombre de Usuario",
      rol:"Administrador",

    },
    drawer: null,
    items: [
      { title: 'USUARIOS', icon: 'assignment_ind' },
      { title: 'BENEFICIARIOS', icon: 'people' }
    ],
  })
}
</script>
